import { graphql } from 'gql'

export const GET_WORKSPACE_AMAZON = graphql(`
  query getWorkspaceAmazon($workspaceId: ID!) {
    workspaceAmazon(workspaceId: $workspaceId) {
      ...WorkspaceAmazonFragmentForGet
    }
  }
`)
